import VerifiedWithCopy from './VerifiedWithCopy.component';

export default VerifiedWithCopy;
